export default "__VITE_ASSET__B8ez5cpk__"